var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"truncate",attrs:{"id":_vm.tooltipId}},[_vm._v(_vm._s(_vm.text))]),(_vm.isOverflown)?_c('b-tooltip',{attrs:{"target":_vm.tooltipId,"container":_vm.containerId}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }